export default __webpack_public_path__ + "static/media/bmw-banner.67b19fd8.jpg";